import React from 'react';

import './style.css';

class ListGroup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      title,
      description,
      containerClassName = '',
      titleClassName = '',
      descriptionClassName = '',
      count,
      children,
      ListFooterComponent,
      horizontal,
      center,
      maxElements = 100
    } = this.props;

    const countClass = `items-row-${count}`;

    return (
      <section
        className={`${containerClassName} list-group-container ${countClass}`}>
        {(React.isValidElement(title) && title) ||
          (Boolean(title) && (
            <p className={`list-group-heading-text ${titleClassName} `}>
              {title}
            </p>
          ))}

        {Boolean(description) && (
          <span
            className={`list-group-description-text ${descriptionClassName}`}>
            {description}
          </span>
        )}

        <div
          className={`list-group-content ${center ? 'list-center ' : ''} ${
            horizontal ? 'mobile-horizontal-container' : ''
          }`}>
          {React.Children.map(children, (child, index) => {
            return React.isValidElement(child) && index < maxElements
              ? React.cloneElement(child, {
                  className: `list-group-list-item ${
                    horizontal ? 'mobile-horizontal-item' : ''
                  }`
                })
              : null;
          })}
        </div>

        {React.isValidElement(ListFooterComponent) && ListFooterComponent}
      </section>
    );
  }
}

export default ListGroup;



// WEBPACK FOOTER //
// ./src/Components/ListGroup/index.js